import { useState } from 'react';
import './DealerPasswordChangeForm.scss';

function getPasswordConstraints(password) {
  return {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}<>_\-\\[\]/`~;'=+]/.test(password),
  };
}

export default function DealerPasswordChangeForm({ dealer, onSubmit, user}) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const constraints = getPasswordConstraints(newPassword);

  
  const passwordsMatch =
    confirmPassword.length === 0 || newPassword === confirmPassword;

  const isPasswordStrong =
    constraints.length &&
    constraints.upper &&
    constraints.lower &&
    constraints.number &&
    constraints.special;

  const isFormValid =
    newPassword.length > 0 &&
    confirmPassword.length > 0 &&
    passwordsMatch &&
    isPasswordStrong;


  function handleSubmit(e) {
    e.preventDefault();

    setError('');

    if (!newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match.');
      return;
    }

    if (
      !constraints.length ||
      !constraints.upper ||
      !constraints.lower ||
      !constraints.number ||
      !constraints.special
    ) {
      setError('Password does not meet all requirements.');
      return;
    }



    onSubmit({ newPassword });
  }
  const isDEU = !dealer?.dealer_number;

  return (
    <div className="password-change-form-wrapper">
      <div className="password-change-form"> 
        <h3>
          {isDEU
            ? `Change Password for ${user?.primaryEmail}`
            : `Change Password for Dealer ${dealer.dealer_number} ${dealer.dealer_name}`}
        </h3>
        {user?.data?.mail && (
          <div className="dealer-primary-contact-email"> {user?.data?.mail}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div>
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
            />

            <ul className="password-constraints">
              <li className={constraints.length ? 'met' : 'unmet'}>
                At least 8 characters
              </li>
              <li className={constraints.upper ? 'met' : 'unmet'}>
                One uppercase letter
              </li>
              <li className={constraints.lower ? 'met' : 'unmet'}>
                One lowercase letter
              </li>
              <li className={constraints.number ? 'met' : 'unmet'}>
                One number
              </li>
              <li className={constraints.special ? 'met' : 'unmet'}>
                One special character
              </li>
            </ul>
          </div>

          <div>
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}

            />

            {!passwordsMatch && (
              <div className="error">
                Passwords do not match.
              </div>
            )}
          </div>

          {error && <div className="error">{error}</div>}

          <button
            type="submit"
            disabled={!isFormValid}
          >
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
}
